/** Render a ``last_active_at`` ISO into a short human label.
 *
 *    null      → "Never"
 *    < 60s     → "Just now"
 *    < 60m     → "{n}m ago"
 *    < 24h     → "{n}h ago"
 *    < 7d      → "{n}d ago"
 *    older     → calendar date in local tz
 *
 *  The relative form lets the operator scan the People table and
 *  see at a glance who's been active recently without having to
 *  parse a bunch of identical-looking ISO strings.
 *  Returns ``"-"`` only on parse error so the column never shows a
 *  raw "Invalid Date".
 */
export function formatLastLogin(iso: string | null | undefined): string {
  if (!iso) return "Never";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "-";
  const now = Date.now();
  const ms = now - d.getTime();
  if (ms < 0) return d.toLocaleDateString();
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return "Just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return d.toLocaleDateString();
}

/** Tooltip-friendly absolute timestamp for a ``last_active_at``.
 *  Returns ``""`` (so callers can spread into a ``title`` attribute
 *  conditionally) when null. */
export function formatLastLoginAbsolute(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString();
}
